module.exports = __webpack_public_path__ + "img/default-ht.c940839a.png";